import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FilterAltSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FilterAltSVG;
